import React from 'react'

import * as S from './styles'

import formatTimestamp from '../../helpers/helper-format-timestamp'

import IProps from './props'

const ChatCard = ({ chat, onClick }: IProps) => (
  <S.Container onClick={() => onClick(chat.id)}>
    {chat.imgUrl && <S.Image src={chat.imgUrl} />}
    <S.ChatDescription>
      <S.ChatTitle>{chat.title}</S.ChatTitle>
      <S.LastMessage>{chat.lastMessage}</S.LastMessage>
    </S.ChatDescription>
    <S.LastMessageDate>
      {formatTimestamp(chat.lastMessageDate)}
    </S.LastMessageDate>
    {chat.hasNewMessage && <S.RedCircle />}
  </S.Container>
)

export default ChatCard
